import { nativeApp } from './native-app';

/** Tempos da abertura a frio, em ms desde o início da navegação. `null` = a etapa não aconteceu. */
export interface ColdOpenTimings {
  authInfoMs: number | null;
  cachedShownMs: number | null;
  gateMs: number;
  outcome: string;
  /** O service worker já controlava a página nesta abertura (1) ou não (0); sem SW o casco guardado não existe. */
  sw?: boolean;
}

/**
 * Texto de diagnóstico da abertura a frio, para separar o custo da PÁGINA do custo do SERVIDOR (FULL ca283493, 17/10):
 * `html_ttfb` é o tempo do servidor até o primeiro byte do HTML; `auth_info` é a ida da verificação de sessão;
 * `cache_shown` é quando a conversa guardada apareceu sem esperar o servidor; `gate` é quando a verificação terminou;
 * `dcl` é quando o código da página terminou de subir. Sem conteúdo do usuário.
 */
export function coldOpenDetail(t: ColdOpenTimings, nav?: Pick<PerformanceNavigationTiming, 'responseStart' | 'domContentLoadedEventEnd'> | null): string {
  const part = (name: string, value: number | null | undefined): string | null => (value == null || !Number.isFinite(value) ? null : `${name}=${Math.round(value)}`);
  return [
    part('html_ttfb', nav?.responseStart),
    part('dcl', nav?.domContentLoadedEventEnd || null),
    part('auth_info', t.authInfoMs),
    part('cache_shown', t.cachedShownMs),
    part('gate', t.gateMs),
    t.sw === undefined ? null : `sw=${t.sw ? 1 : 0}`,
    `outcome=${t.outcome}`,
  ].filter(Boolean).join(' ');
}

/** Registra a abertura a frio na fila de diagnóstico do app (só no app Android; no navegador não faz nada). */
export function reportColdOpen(t: ColdOpenTimings): void {
  try {
    const app = nativeApp();
    if (!app?.recordDiagnostic) return;
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    void app.recordDiagnostic({ kind: 'app_cold_open', detail: coldOpenDetail({ ...t, sw: !!navigator.serviceWorker?.controller }, nav), where: window.location.pathname }).catch(() => undefined);
  } catch { /* diagnóstico nunca atrapalha a abertura */ }
}
